export const UNDO_MODAL_WIDTH = 700;

export enum UndoSelectorType {
  resetToVersion,
  undoMapDeletion,
  undoSpecificAction
}
